export default __webpack_public_path__ + "static/media/information.57fad56b.svg";